import { useState, useEffect } from 'react';
import Page from '../components/Page';
import image from '../static/images/Option-2.webp';


const Colophon = (props) => {

  const [innerContent, setInnerContent] = useState('');
  const [innerContentEN, setInnerContentEN] = useState('');




  useEffect(() => {
    fetch('./content/colophon-NL.html').then((response) => {
    return response.text();
    }).then((html) => {
    setInnerContent(html);
  });

    fetch('./content/colophon-EN.html').then((response) => {
    return response.text();
    }).then((html) => {
    setInnerContentEN(html);
  });
    },[]);

  const content = <div className="content"
    dangerouslySetInnerHTML={{__html: innerContent ? innerContent : ''}}></div>

  const contentEN = <div className="content"
  dangerouslySetInnerHTML={{__html: innerContentEN ? innerContentEN : ''}}></div>

  document.title = 'Colophon - De School Amsterdam';
  const headerTitle = props.langNL ? 'Colofon' : 'Colophon';
  const description = props.langNL ? 'Colofon Colofon Colofon Colofon Colofon Colofon': 'Colophon Colophon Colophon Colophon Colophon Colophon';


  return <Page
          headerTitle={headerTitle}
          description={description}
          content={props.langNL ? content : contentEN}
          image={image}
          langNL={props.langNL}
          changeLang={props.changeLang}/>


};

export default Colophon;
